@if (profile$ | async; as profile) {
	<section id="profile">
		@if (!profile.needs_tenancy_terms_approve) {
			<div class="bp-modal-body-section mod-custom-bottom mod-middle-pt">
				<div class="form-row">
					<bp-input
						class="form-group mb-0 mod-half"
						[type]="'text'"
						[iconLeading]="true"
						[placeholder]="'forename' | translate"
						[label]="'forename' | translate"
						[model]="profile"
						field="forename"
						[error]="profile.getValidationError('forename') | translate"></bp-input>
					<bp-input
						class="form-group mb-0 mod-half"
						[type]="'text'"
						[iconLeading]="true"
						[placeholder]="'surname' | translate"
						[label]="'surname' | translate"
						[model]="profile"
						field="surname"
						[error]="profile.getValidationError('surname') | translate"></bp-input>
				</div>
				<bp-input
					[iconLeading]="true"
					[formatted-output]="true"
					[label]="'birthday' | translate"
					[model]="profile"
					field="fullBirthday"
					[type]="'birthdate'"
					(onFocusOut)="validateDateOfBirth($event, profile)"
					[error]="profile.getValidationError('fullBirthday') | translate"></bp-input>
				<div>
					@if (profile.country_id === GERMANY_COUNTRY_ID) {
						@if (isGoogleSearchBop) {
							<label class="label-section"> {{ "place_of_birth" | translate }} </label>
							<div>
								<bp-place-of-birth-autocomplete
									(click)="trackPlaceOfBirthClick()"
									[model]="profile"
									[profile]="profile"
									[placeholder]="'search_city_and_country' | translate"
									(cityNotFound)="setCityNotFound()"
									(onPlaceOfBirthUpdate)="
										getPlaceOfBirth($event, profile)
									"></bp-place-of-birth-autocomplete>
							</div>
						} @else {
							<!-- Manual place of birth enter -->
							<bp-input
								[type]="'text'"
								class="form-group mod-three-quarter mb-0"
								iconLeading="true"
								[placeholder]="('city' | translate) + ', ' + ('country' | translate)"
								[label]="'place_of_birth' | translate"
								[model]="profile"
								field="manual_date_of_birth"
								(onFocusOut)="validateManualPlaceOfBirth($event, profile)"
								(valueChange)="onPlaceOfBirthValueChange($event, profile)"
								[error]="profile.getValidationError('manual_date_of_birth') | translate">
							</bp-input>
						}
						@if (pobCityNotFound) {
							<div class="pt-10 text-center">
								<a
									(click)="switchBetweenManualBop(profile)"
									(keydown.enter)="switchBetweenManualBop(profile)"
									[tabIndex]="0"
									class="font-medium">
									{{
										isGoogleSearchBop
											? "add_pob_manually_cta"
											: ("add_pob_via_google_cta" | translate)
									}}
								</a>
							</div>
						}
					}
				</div>
			</div>
			<hr class="mb-0 mt-0" />
			<div class="bp-modal-body-section mod-custom-bottom mod-middle-pt">
				@if (isGoogleSearchAddress) {
					<label class="label-section"> {{ "street_door_number" | translate }}</label>
					<div>
						<bp-google-autocomplete
							[model]="profile"
							[profile]="profile"
							[placeholder]="'autofill_address_placeholder' | translate"
							[bottomLabel]="'autofill_address_bottom_label' | translate"
							[showManualAddressEdit]="false"
							(onSuggestionsUpdate)="getAddressData($event, profile)"
							[googleCountryRestriction]="isoAllowedCountries"></bp-google-autocomplete>
					</div>
					<div class="pt-10 text-center">
						<a
							(click)="switchBetweenAddressesForms(profile)"
							(keydown.enter)="switchBetweenAddressesForms(profile)"
							[tabIndex]="0"
							class="font-medium">
							{{ "debit_card_address_input_add" | translate }}
						</a>
					</div>
				} @else {
					<bp-input
						#streetNumberInput
						[type]="'text'"
						iconLeading="true"
						[placeholder]="'street_door_number' | translate"
						[label]="'street_door_number' | translate"
						[model]="profile"
						field="street"
						(valueChange)="onValueChange($event, streetNumberInput)"
						(focusout)="onInputFocusOut($event, profile)"
						[error]="profile.getValidationError('street') | translate">
					</bp-input>
					<div class="form-row">
						<bp-input
							[type]="'text'"
							class="form-group mod-quarter mb-0"
							iconLeading="true"
							[placeholder]="'zipcode' | translate"
							[label]="'zipcode' | translate"
							[model]="profile"
							field="zipcode"
							[error]="profile.getValidationError('zipcode') | translate">
						</bp-input>
						<bp-input
							[type]="'text'"
							class="form-group mod-three-quarter mb-0"
							iconLeading="true"
							[placeholder]="'city' | translate"
							[label]="'city' | translate"
							[model]="profile"
							field="city"
							[error]="profile.getValidationError('city') | translate">
						</bp-input>
					</div>
					<div class="pt-10 text-center">
						<a
							(click)="switchBetweenAddressesForms(profile)"
							(keydown.enter)="switchBetweenAddressesForms(profile)"
							[tabIndex]="0"
							class="font-medium">
							{{ "manual_address_to_autofill" | translate }}
						</a>
					</div>
				}

				<div class="form-group" [ngClass]="{ 'has-error': profile?.hasError('country_id') }">
					<label for="country">{{ "personal_data_country_of_residence" | translate }}</label>
					<bp-select
						id="country"
						class="verification-select"
						[options]="countryOptions"
						[selectedValue]="!!profile.country_id ? profile.country_id : '14'"
						[countrySelection]="true"
						[disabled]="!user()?.profileModifiable()"
						[searchable]="true"
						[clearable]="false"
						[searchTermOnClose]="selectedCountryName(profile)"
						[bindLabel]="'name'"
						(selectedValueChange)="onCountrySelect($event, profile)"
						[error]="profile?.getValidationError('country_id')">
					</bp-select>
				</div>

				@if (displayTCAdditionalInfo()) {
					<div class="tc-notification" [ngClass]="{ 'mb-20': countrySelected?.getSsnRequired() }">
						<p>{{ "changed_country_of_residence" | translate: [countrySelected.getI18Nname()] }}</p>

						@if (showTCAdditionalInfo) {
							<p>{{ "changed_country_of_residence_info" | translate }}.</p>
						}
					</div>
				}
			</div>
			<hr class="mb-0 mt-0" />
			<div class="bp-modal-body-section mod-custom-bottom mod-middle-pt">
				<bp-input-phone
					[model]="profile"
					field="mobile"
					[countries]="phoneCodeOptions"
					[disabled]="!user()?.profileModifiable()"
					[phoneCode]="phoneCode"
					[error]="profile?.hasError('mobile')"
					[countrySelected]="countrySelected"
					(valueChange)="onMobileChange($event, profile)"></bp-input-phone>
			</div>
			<hr class="mb-0 mt-0" />
			<div class="bp-modal-body-section mod-middle-pt">
				<bp-switch
					[css]="'items-start'"
					[model]="profile"
					field="accepted_terms_data"
					(modelChange)="trackTermsData()">
					<ng-container left>
						<p class="font-size-17 large-weight">{{
							"important_text_about_saving_level3_data" | translate
						}}</p>
						@if (countrySelected?.isEMoney()) {
							<span class="font-size-14 emoney">{{
								"pers_details_phone_emoney_legal_text_de" | translate
							}}</span>
							<span
								class="emoney__icon bpi__icon-info"
								[bp-tooltip]="'pers_details_phone_emoney_moreinfo_text' | translate"
								position="right"
								[tabIndex]="0"></span>
						}
					</ng-container>
				</bp-switch>
				<div>
					<span class="font-size-14 emoney">
						{{ "personal_details_phone_emoney_text" | translate }}
					</span>
					<span
						class="emoney__icon bpi__icon-info"
						[bp-tooltip]="'personal_details_phone_emoney_info_text' | translate"
						position="right"
						[tabIndex]="0"></span>
				</div>
				<div class="warning text-base-black mt-40">
					{{ "important_text_about_saving_level3_data_small" | translate }}
				</div>
				<div class="justify-end">
					<div class="mod-button-width">
						<loading-button
							[text]="'verification_save_and_continue_button'"
							[type]="'submit'"
							(onClick)="update(profile)"
							[disabled]="false"
							[buttonStyle]="'btn-primary mod-button-width button-weight font-size-14'"
							[styles]="!profile?.accepted_terms_data ? 'disabled' : ''"></loading-button>
					</div>
				</div>
			</div>
		} @else {
			@if (dynamicTermsAndConditionsActive) {
				<div class="bp-modal-body-section">
					@for (bundle of bundles; track bundle.agreement_bundle_version_id) {
						@if (bundle.change_summary) {
							<p class="text-center font-size-13">{{ bundle.change_summary }}</p>
						}
					}
					<div class="text-center">
						<terms-and-conditions-updates
							[hasNoticeImplicitConsent]="true"
							[bundles]="bundles"></terms-and-conditions-updates>
					</div>
					<div class="text-center">
						<loading-button
							[text]="'terms_and_conditions_accept_new_button'"
							(onClick)="onTenancyTermsAccept()"
							[buttonStyle]="'btn-primary button-weight font-size-14'"></loading-button>
					</div>
				</div>
			}
		}
	</section>
}
